"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
require("./icon-button.css");
var _excluded = ["ariaLabel", "children", "className", "highContrast", "href", "iconClass", "onClick", "path", "size", "style", "tagName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A button for use with a single `Icon`. Please see `Icon` for further information.
 */

var IconButton = function IconButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    highContrast = _ref.highContrast,
    href = _ref.href,
    iconClass = _ref.iconClass,
    onClick = _ref.onClick,
    path = _ref.path,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24px' : _ref$size,
    style = _ref.style,
    tagName = _ref.tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!children && !path) {
    return null;
  }
  var TagName = tagName || (href ? 'a' : 'button');
  return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    "aria-label": ariaLabel,
    className: (0, _classnames["default"])('sb-iconButton position-relative', _defineProperty(_defineProperty({}, className, Boolean(className)), 'sb-iconButton-highContrast', Boolean(highContrast))),
    href: href,
    onClick: onClick,
    style: _objectSpread({
      minWidth: '44px',
      minHeight: '44px'
    }, style)
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    children: children,
    className: (0, _classnames["default"])('absoluteCenter', _defineProperty({}, iconClass, Boolean(iconClass))),
    defaultHoverStyling: !highContrast,
    isInteractive: true,
    path: path,
    size: size
  }));
};
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `aria-label` applied to button.
   */
  ariaLabel: _propTypes["default"].string,
  /**
   * optional prop to allow button to be seen more easily on dark backgrounds
   */
  highContrast: _propTypes["default"].bool,
  /**
   * optional href for use if button is to be a link
   */
  href: _propTypes["default"].string,
  /**
   * optional class applied to icon
   */
  iconClass: _propTypes["default"].string,
  /**
   * path of the icon to be used
   */
  path: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * Size passed through to Icon child
   */
  size: _propTypes["default"].string,
  /**
   * Tag for this element can only be
   * `button` or `a`, since this component is interactive.
   */
  tagName: _propTypes["default"].oneOf(['a', 'button'])
} : {};
IconButton.displayName = 'IconButton';
var _default = exports["default"] = IconButton;